import React, { useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import CarSelector from '../components/CarSelector';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#models-section') {
      const el = document.getElementById('models-section');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  const handleModelSelect = (model) => {
    const key = model.slug || model.id;
    navigate(`/models/${key}`);
  };

  return (
    <div className="home-page">
      <section className="hero-section hero-section--store">
        <div className="container">
          <div className="hero-content">
            <div className="hero-logo">
              <img src="/logo.png" alt="حمزة لكماليات وقطع غيار مرسيدس بنز" className="hero-logo-img" />
            </div>
            <h1 className="hero-title">
              حمزة لكماليات وقطع غيار <span className="highlight">مرسيدس</span> <span className="highlight">بنز</span>
            </h1>
            <p className="hero-subtitle">
              اختر موديل سيارتك واطلب القطع التي تحتاجها — جودة عالية وأسعار منافسة
            </p>
            <div className="hero-cta">
              <button
                className="btn btn-primary btn-large"
                onClick={() => document.getElementById('models-section').scrollIntoView({ behavior: 'smooth' })}
              >
                تصفح الموديلات
              </button>
              <Link to="/about" className="btn btn-secondary btn-large hero-link-about">
                من نحن
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section id="models-section" className="models-section models-section--featured">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">موديلات مرسيدس</h2>
            <p className="section-subtitle">
              اختر موديل سيارتك ثم الطراز للوصول إلى قطع الغيار المتاحة
            </p>
          </div>
          <CarSelector onSelectModel={handleModelSelect} showTitle={false} />
        </div>
      </section>

      <section className="home-cta-strip">
        <div className="container">
          <p className="home-cta-strip-text">لم تجد ما تبحث عنه؟ تواصل معنا عبر واتساب</p>
          <Link to="/about" className="home-cta-strip-link">تعرف على خدماتنا</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
